<div class="dropdown">
  <button class="dropbtn" [innerHTML]="applyStyle(selectedItem)" (click)="toggle()"></button>
  <div [class.is-open]="isOpen" class="dropdown-content">
    <div [class.selected]="item == selectedItem" *ngFor="let item of items" [innerHTML]="applyStyle(item)" (click)="onItemClick(item)">
    </div>
  </div>
</div>